import * as url from "../url_helper";

import { post,get } from "../api_helper";

export const getRegion = data => get(url.GET_REGION, data);

export const getAllRegions = data => post(url.GET_DROP_DOWN_KEY_VALUES, data);
